import React, { useState } from 'react';
import styled from 'styled-components';
import useTranslation from 'next-translate/useTranslation';
import { useCommentMusicKnowledgeHub } from '../../../api';
import { Input, Button } from '../../../VuexyDesign/atoms/_index';
import { Text, Red } from '../../common/Text';
import useLoginWithRedirect from '../../../hooks/useLoginWithRedirect';

const CommentsReplyForm = ({
  postId,
  commentId,
  isSubmitting,
  errorMessage,
  hide,
}: {
  postId: number;
  commentId: number;
  isSubmitting?: boolean;
  errorMessage?: string;
  hide: () => void;
}) => {
  const { t } = useTranslation('tracks');
  const [submitted, setSubmitted] = useState(false);
  const [message, setMessage] = useState('');
  const { reply, data: comment } = useCommentMusicKnowledgeHub(commentId);
  const redirect = useLoginWithRedirect(false);

  if (!comment) {
    return null;
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await redirect();
    await reply(
      { postId, message },
      {
        onSuccess: () => {
          setMessage('');
          hide();
          setSubmitted(true);
        },
      },
    );
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMessage(e.target.value);
  };

  return (
    <Container onSubmit={handleSubmit}>
      <Row>
        <Input
          name="playlist"
          value={message}
          onChange={onChange}
          className="text-dark"
        />
        <SendReply
          color="primary"
          disabled={isSubmitting}
          text={t('tracks:sendReply') as string}
        />
      </Row>
      {errorMessage && submitted && (
        <Row>
          <Text>
            <Red>{errorMessage}</Red>
          </Text>
        </Row>
      )}
    </Container>
  );
};

export default CommentsReplyForm;

const SendReply = styled(Button)`
  white-space: nowrap;
  min-height: auto;
`;

const Container = styled.form`
  display: flex;
  margin-top: 18px;
  flex-direction: column;
  width: 100%;

  ${Text} {
    padding-left: 20px;
  }
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  padding-bottom: 10px;
`;
